import axios from 'axios';
import { io, Socket } from 'socket.io-client';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export interface LogEntry {
  id: number;
  timestamp: string;
  level: 'info' | 'error' | 'warn' | 'success' | 'debug';
  message: string;
  data?: string;
}

class LogService {
  private socket: Socket | null = null;

  connect(): Socket {
    if (!this.socket) {
      this.socket = io({
        withCredentials: true
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  getLogs(limit = 100) {
    return axios.get(`${API_BASE_URL}/logs?limit=${limit}`);
  }

  clearLogs() {
    return axios.delete(`${API_BASE_URL}/logs`);
  }

  triggerEmailProcessing() {
    return axios.post(`${API_BASE_URL}/logs/test`);
  }

  testGmailConnection() {
    return axios.post(`${API_BASE_URL}/logs/test-gmail`);
  }

  testAIConnection() {
    return axios.post(`${API_BASE_URL}/logs/test-ai`);
  }

  testOllamaConnection() {
    return axios.post(`${API_BASE_URL}/logs/test-ollama`);
  }
}

export default new LogService();